/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ReportCostsByEmploymentTypeRollup } from './ReportCostsByEmploymentTypeRollup';
import {
    ReportCostsByEmploymentTypeRollupFromJSON,
    ReportCostsByEmploymentTypeRollupFromJSONTyped,
    ReportCostsByEmploymentTypeRollupToJSON,
    ReportCostsByEmploymentTypeRollupToJSONTyped,
} from './ReportCostsByEmploymentTypeRollup';
import type { ReportCostsByEmploymentType } from './ReportCostsByEmploymentType';
import {
    ReportCostsByEmploymentTypeFromJSON,
    ReportCostsByEmploymentTypeFromJSONTyped,
    ReportCostsByEmploymentTypeToJSON,
    ReportCostsByEmploymentTypeToJSONTyped,
} from './ReportCostsByEmploymentType';

/**
 * 
 * @export
 * @interface ListShiftCostReportsByEmploymentTypeResponse
 */
export interface ListShiftCostReportsByEmploymentTypeResponse {
    /**
     * 
     * @type {Array<ReportCostsByEmploymentType>}
     * @memberof ListShiftCostReportsByEmploymentTypeResponse
     */
    data: Array<ReportCostsByEmploymentType>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListShiftCostReportsByEmploymentTypeResponse
     */
    pagination: Pagination;
    /**
     * 
     * @type {ReportCostsByEmploymentTypeRollup}
     * @memberof ListShiftCostReportsByEmploymentTypeResponse
     */
    rollup: ReportCostsByEmploymentTypeRollup;
}

/**
 * Check if a given object implements the ListShiftCostReportsByEmploymentTypeResponse interface.
 */
export function instanceOfListShiftCostReportsByEmploymentTypeResponse(value: object): value is ListShiftCostReportsByEmploymentTypeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('rollup' in value) || value['rollup'] === undefined) return false;
    return true;
}

export function ListShiftCostReportsByEmploymentTypeResponseFromJSON(json: any): ListShiftCostReportsByEmploymentTypeResponse {
    return ListShiftCostReportsByEmploymentTypeResponseFromJSONTyped(json, false);
}

export function ListShiftCostReportsByEmploymentTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListShiftCostReportsByEmploymentTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ReportCostsByEmploymentTypeFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
        'rollup': ReportCostsByEmploymentTypeRollupFromJSON(json['rollup']),
    };
}

  export function ListShiftCostReportsByEmploymentTypeResponseToJSON(json: any): ListShiftCostReportsByEmploymentTypeResponse {
      return ListShiftCostReportsByEmploymentTypeResponseToJSONTyped(json, false);
  }

  export function ListShiftCostReportsByEmploymentTypeResponseToJSONTyped(value?: ListShiftCostReportsByEmploymentTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ReportCostsByEmploymentTypeToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
        'rollup': ReportCostsByEmploymentTypeRollupToJSON(value['rollup']),
    };
}

